<template>
  <div>
    <div class="edit-wan-modal">
      <div class="modal__container--header edit-wan-modal__header">
        <div class="text">
          {{header}}
        </div>
        <div class="close pointer">
          <span @click="close" class="mdi mdi-close"></span>
        </div>
      </div>
      <div class="edit-wan-modal__container">
        <div class="edit-wan-modal__container--row">
          <div class="row__input">
            <label class="inp" style="position: relative;">
              {{ translate('device.config_dashboard.WAN_route_man.name') }}
              <!-- <span
                class=" mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.name = true"
                @mouseleave="text_assistant.name = false"
              >
                <span class="hide_text name" :class="{ active: text_assistant.name}">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <input
                type="text"
                class="text"
                style="height: 40px"
                v-model="data.tap"
                :class="{
                  invalid:
                    $v.data.tap.$dirty && !$v.data.tap.required,
                }"
              />
              <small
                class="red-text-12"
                v-if="
                  $v.data.tap.$dirty && !$v.data.tap.required
                "
                >{{ translate('device.config_dashboard.empty_input') }}</small
              >
            </label>
          </div>
        </div>

        <div class="additionally">
          <div >
            <div class="edit-wan-modal__container--row" style="margin-right: 30px;">
              <div style="padding: 0 0 0 10px">
                <svg width="10" height="16" viewBox="0 0 10 16">
                  <path
                    d="M4 14C4 15.1 3.1 16 2 16C0.9 16 0 15.1 0 14C0 12.9 0.9 12 2 12C3.1 12 4 12.9 4 14ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM8 4C9.1 4 10 3.1 10 2C10 0.9 9.1 0 8 0C6.9 0 6 0.9 6 2C6 3.1 6.9 4 8 4ZM8 6C6.9 6 6 6.9 6 8C6 9.1 6.9 10 8 10C9.1 10 10 9.1 10 8C10 6.9 9.1 6 8 6ZM8 12C6.9 12 6 12.9 6 14C6 15.1 6.9 16 8 16C9.1 16 10 15.1 10 14C10 12.9 9.1 12 8 12Z"
                    fill="#515459"
                  />
                </svg>
              </div>
              <div class="row__input server_port">
                <label class="inp" style="position: relative;">
                  {{ translate('device.config_dashboard.WAN_route_man.server') }}
                  <!-- <span
                    class=" mdi mdi-help-circle-outline"
                    style="font-size: 18px; color: #c3c7ca; position: relative"
                    @mouseover="text_assistant.server = true"
                    @mouseleave="text_assistant.server = false"
                  >
                    <span class="hide_text server" :class="{ active: text_assistant.server}">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    </span>
                  </span> -->
                  <input
                    type="text"
                    class="text"
                    v-model="data.multi_server"
                    :class="{
                      invalid:
                        $v.data.multi_server.$dirty && !$v.data.multi_server.required,
                    }"
                  />
                  <small
                    class="red-text-12"
                    v-if="
                      $v.data.multi_server.$dirty && !$v.data.multi_server.required
                    "
                    >{{ translate('device.config_dashboard.empty_input') }}</small
                  >
                </label>
              </div>
              <div class="row__input server_port">
                <label class="inp">
                  {{ translate('device.config_dashboard.WAN_route_man.port') }}
                  <!-- <span
                    class=" mdi mdi-help-circle-outline"
                    style="font-size: 18px; color: #c3c7ca; position: relative"
                    @mouseover="text_assistant.port = true"
                    @mouseleave="text_assistant.port = false"
                  >
                    <span class="hide_text port" :class="{ active: text_assistant.port}">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    </span>
                  </span> -->
                  <input
                    type="text"
                    class="text"
                    v-model="data.server_port"
                  />
                </label>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="edit-wan-modal__container--row">
            <label style="padding: 0px" class="inp">
              {{ translate('device.config_dashboard.WAN_route_man.method_ipv') }}
              <!-- <span
                class=" mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.method_ipv4 = true"
                @mouseleave="text_assistant.method_ipv4 = false"
              >
                <span class="hide_text method_ipv4" :class="{ active: text_assistant.method_ipv4}">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
            </label>
          </div>
        </div>

        <div
          class="edit-wan-modal__container--row">
          <div class="row__label">
            <div class="d-inline-block">
              <input
                type="radio"
                id="auto"
                value="auto"
                v-model="radioIpv4"
                name="radio-group-method"
              />
              <label for="auto">{{ translate('device.config_dashboard.WAN_route_man.automatically') }}</label>
            </div>
            <div class="d-inline-block">
              <input
                type="radio"
                id="manual"
                value="manual"
                v-model="radioIpv4"
                name="radio-group-method"
              />
              <label for="manual">{{ translate('device.config_dashboard.WAN_route_man.manually') }}</label>
            </div>
          </div>
        </div>

        <div
        v-if="radioIpv4 == 'manual'"
          class="edit-wan-modal__container--row"
        >
          <div class="row__input" style="max-width: 168px">
            <label class="inp">
              {{ translate('device.config_dashboard.WAN_route_man.ip_address') }}
              <!-- <span
                class=" mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.ip_address = true"
                @mouseleave="text_assistant.ip_address = false"
              >
                <span class="hide_text ip_address" :class="{ active: text_assistant.ip_address}">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <input
                type="text"
                class="text"
                v-model="data.local_ip"
              />

            </label>
          </div>
          <div class="row__input" style="max-width: 168px">
            <label class="inp">
              {{ translate('device.config_dashboard.WAN_route_man.mask') }}
              <!-- <span
                class=" mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.mask = true"
                @mouseleave="text_assistant.mask = false"
              >
                <span class="hide_text mask" :class="{ active: text_assistant.mask}">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <input
                type="text"
                class="text"
                v-model="data.local_mask"
              />

            </label>
          </div>
          <div class="row__input" style="max-width: 168px">
            <label class="inp">
              {{ translate('device.config_dashboard.WAN_route_man.gateway') }}
              <!-- <span
                class=" mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.gateway = true"
                @mouseleave="text_assistant.gateway = false"
              >
                <span class="hide_text gateway" :class="{ active: text_assistant.gateway}">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <form id="" method="post" action="" autocomplete="off">
                <input
                  type="text"
                  class="text"
                  autocomplete="off"
                  v-model="data.gateway"
                />
              </form>
            </label>
          </div>
        </div>

        <div class="edit-wan-modal__container--row">
          <label class="switch">
            {{ translate('device.config_dashboard.WAN_route_man.use_as_default_route') }}
          <!-- <span
            class=" mdi mdi-help-circle-outline"
            style="font-size: 18px; color: #c3c7ca; position: relative"
            @mouseover="text_assistant.default_route = true"
            @mouseleave="text_assistant.default_route = false"
          >
            <span class="hide_text default_route" :class="{ active: text_assistant.default_route}">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </span>
          </span> -->
            <input
              type="checkbox"
              v-model="default_route"
            />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="edit-wan-modal__container--row">
          <div class="row__input" style="position: relative">
            <label class="inp">
              {{ translate('device.config_dashboard.WAN_route_man.interfaces') }}
              <!-- <span
                class=" mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.interfaces = true"
                @mouseleave="text_assistant.interfaces = false"
              >
              <span class="hide_text interfaces" :class="{ active: text_assistant.interfaces}">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </span>
            </span> -->
            </label>
              <multiselect
              class="multiselect_test"
              track-by="name"
              :custom-label="({ name }) => `${name}`"
              v-model='$v.selectedInterfaces.$model'
              :options='wanOptions'
              :multiple="true"
              :clear-on-select="false"
              :placeholder="''"
              :selectLabel="''"
              :selectedLabel="''"
              :deselectLabel="''"
              :taggable="true"
              @tag="addTag"
              :class="{
                  invalid_select:
                    ($v.selectedInterfaces.$dirty && !$v.selectedInterfaces.required) ||
                    ($v.selectedInterfaces.$anyError && !$v.selectedInterfaces.validationInterfaces)
                }"
              />
              <!-- <small
                class="red-text-12"
                style="font-weight: 700;"
                v-if="
                  $v.selectedInterfaces.$dirty && !$v.selectedInterfaces.required
                "
                >{{ translate('device.config_dashboard.empty_input') }}</small
              > -->
              <small
                class="red-text-12"
                style="font-weight: 700;"
                v-if="
                  ($v.selectedInterfaces.$dirty && !$v.selectedInterfaces.required) || ($v.selectedInterfaces.$anyError && !$v.selectedInterfaces.validationInterfaces)
                "
                >{{ translate('device.config_dashboard.incorrect_value') }}</small
              >
          </div>
        </div>

        <div
          style="margin: 0 0 12px"
          class="additionally">
          <div class="edit-wan-modal__container--row">
            <label style="padding: 4px 0 4px 4px" class="switch">
              {{ translate('device.config_dashboard.WAN_route_man.additional_settings') }}
            </label>
            <div style="margin: 0 0 -5px 0" class="chevron pointer">
              <span
                class="mdi mdi-chevron-down"
                @click="additional_view = !additional_view"
                :class="{ 'mdi-chevron-up': additional_view }"
              ></span>
            </div>
          </div>
          <div v-show="additional_view">
            <div class="edit-wan-modal__container--row">
              <label style="padding: 0px 0 4px 4px" class="switch">
                {{ translate('device.config_dashboard.WAN_route_man.authorization_data') }}
              </label>
            </div>
            <div class="edit-wan-modal__container--row">
              <div class="row__input">
                <label for="inp_password" style="padding: 0 0 0 4px; position: relative" class="inp">
                  {{ translate('device.config_dashboard.WAN_route_man.password') }}
                  <!-- <span
                    class=" mdi mdi-help-circle-outline"
                    style="font-size: 18px; color: #c3c7ca; position: relative"
                    @mouseover="text_assistant.password = true"
                    @mouseleave="text_assistant.password = false"
                  >
                    <span class="hide_text password" :class="{ active: text_assistant.password}">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    </span>
                  </span> -->
                  <span
                    class="show-password mdi mdi-eye"
                    style="font-size: 18px"
                    :class="{ 'mdi-eye-off': isEyeClass }"
                    @click="showHidePassword"
                  ></span>
                  <input
                    type="password"
                    class="password"
                    id="inp_password"
                    v-model="data.auth"
                  />
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="edit-wan-modal__buttons">
        <span>
          <span @click="deleteWanRouteMan" class="btn btn-danger">
            {{ translate('btn.delete') }}
          </span>
        </span>
        <span>
          <span @click="close" style="margin-right: 10px" class="notice-btn btn-success btn btn-info">
            {{ translate('btn.cancel') }}
          </span>
          <span  @click="save" class="btn btn-success">
            {{ translate('btn.edit') }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Multiselect from 'vue-multiselect'
import { validationMixin } from "vuelidate";
import { required, helpers } from "vuelidate/lib/validators";

const validationInterfaces = helpers.regex(
  "validationInterfaces",
  /^(usb_m|m|M|eth|br|wlan_m|wlan_usb)[\d](.\d)?$/
);

export default Vue.extend({
  components: {
    Multiselect,
  },
  name: "WanRouteManModal",
  mixins: [validationMixin, helpers],
  props: {
    dataRouteMan: Object,
    header: String,
    optionsWAN: Array,
  },
  data: function () {
    return {
      data: {},
      newData: {},
      ifaces: [],
      isEyeClass: false,
      radioWanLan: "lan",
      radioIpv4: "manual",
      selectedInterfaces: [],
      options: [ {} ],
      wanOptions: [],
      default_route: false,
      additional_view: false,
      text_assistant: {
        name: false,
        mode: false,
        default_route: false,
        server: false,
        port: false,
        method_ipv4: false,
        ip_address: false,
        mask: false,
        gateway: false,
        interfaces: false,
        usage_policy: false,
        mtu: false,
        password: false,
      }
    };
  },
  validations () {
    return {
      data: {
        tap: {
          required
        },
        multi_server: {
          required
        },
      },
      selectedInterfaces: {
        required,
        $each: {
          name: {
            validationInterfaces
          }
        }
      },
    };
  },
   methods: {
     save () {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      } else {
          for (let iface of this.selectedInterfaces) {
            this.ifaces.push(iface.name)
          }
        this.newData[this.header] = {
          auth: this.data.auth,
          default_route: this.data.default_route,
          local_ip: this.data.local_ip,
          local_mask: this.data.local_mask,
          gateway: this.data.gateway,
          local_ports: this.data.local_ports,
          multi_iface: this.ifaces,
          multi_server: this.data.multi_server,
          //remote_ports: this.data.remote_ports,
          tap: this.data.tap,
          server_port: this.data.server_port || "2000",
        }
        // console.log(this.newData);
        this.$emit("update", this.newData);
        this.$emit("close");
      }
    },
    deleteWanRouteMan() {
      this.$emit("delete", this.header);
      this.close();
    },
    showHidePassword: function () {
      const input = document.getElementById("inp_password");
      if (input === null) return false;
      if (input.getAttribute("type") == "password") {
        this.isEyeClass = true;
        input.setAttribute("type", "text");
      } else {
        this.isEyeClass = false;
        input.setAttribute("type", "password");
      }
      return false;
    },
    close () {
      this.$emit('close')
    },
    newSelectedInterfaces () {
      if (this.data.multi_iface.indexOf('..') > -1) {
        this.data.multi_iface = this.search_double_dot(this.data.multi_iface)
      } else if (this.data.multi_iface.indexOf(',') > -1) {
          this.data.multi_iface = this.data.multi_iface.split(',')
      }

      if (typeof(this.data.multi_iface) == "object" && this.data.multi_iface != '') {
        for (let i in this.data.multi_iface) {
          this.selectedInterfaces.push ({
            name: this.data.multi_iface[i],
          })
        }
      } else if (this.data.multi_iface != '') {
        this.selectedInterfaces.push ({
            name: this.data.multi_iface,
        })
      }
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
      }
      //const tag = newTag
      this.options.push(tag)
      this.selectedInterfaces.push(tag)
    },
    methodIPv4 () {
      if (this.data.local_ip == "auto") {
        this.radioIpv4 = "auto";
      } else {
        this.radioIpv4 = "manual";
      }
    },
    search_double_dot(string){
      let count_dotter = string.indexOf('..')
      let name = string.substring(0, (count_dotter - 1))
      let number1 = string.substring((count_dotter -1), count_dotter)
      let number2 = string.substring(count_dotter + 2, count_dotter + 3)
      let array = []
      for (let i = number1; i <= number2; i++) {
        array.push('' + name + i + '')
      }
      return array
    },
  },
  created () {
    this.data = {
      auth: this.dataRouteMan.auth || "",
      default_route: this.dataRouteMan.default_route || "",
      local_ip: this.dataRouteMan.local_ip || "",
      local_mask: this.dataRouteMan.local_mask || "",
      gateway: this.dataRouteMan.gateway || "",
      local_ports: this.dataRouteMan.local_ports || "",
      multi_iface: this.dataRouteMan.multi_iface || "",
      multi_server: this.dataRouteMan.multi_server || "",
      //remote_ports: this.dataRouteMan.remote_ports || "5006",
      tap: this.dataRouteMan.tap || "tap0",
      server_port: this.dataRouteMan.server_port || this.dataRouteMan.remote_ports || "2000",
    };
     if (this.data.default_route === "1" || this.data.default_route === "On") {
      this.default_route = true;
    } else if (this.data.default_route === "0" || this.data.default_route === "Off") {
      this.default_route = false;
    }
    this.methodIPv4();
    this.newSelectedInterfaces();
    for (let i in this.optionsWAN) {
      this.wanOptions.push ({
        name: this.optionsWAN[i],
      })
    }

  }
})
  </script>

<style src="assets/sass/radio-button.scss" lang="scss" scoped></style>
<style src="assets/sass/slider-round.scss" lang="scss" scoped></style>
<style src="assets/sass/show-hide-password.scss" lang="scss" scoped></style>

<style lang="scss" scoped>
.edit-wan-modal {
  max-width: 600px;
  padding: 0;

  &__header {
    color: #66615b;;
    font-size: 18px;
    padding: 26px 24px;
    border-bottom: 1px solid #cecfd1;
    display: flex;
    justify-content: space-between;
  }

  &__container {
    padding: 8px 24px;
    max-height: 600px;
    overflow-y: scroll;
    overflow-x: hidden;
    &--row {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin: 20px 0;
      .chevron {
        color: #66615b;
        text-shadow: none;
        font-weight: 400;
        opacity: 1;
        font-size: 25px;
      }
      .plus{
        color: #66615b;
        text-shadow: none;
        font-weight: normal;
        opacity: 1;
        font-size: 25px;
        &.active {
          visibility: hidden;
        }
        &:hover,
        &:focus {
          outline: none;
          color: #66615b !important;
          text-shadow: none !important;
    }
  }

      label {
        margin-bottom: 0;
      }
      .row__label {
        color: gray;
        font-size: 13px;
        display: flex;
        margin-right: 24px;
      }
      .row__input {
        max-width: 268px;
        width: 100%;
         label {
          width: 100%;
        }
        span {
          color: #c3c7ca;
          font-size: 13px;
          font-weight: bold;
        }
        &.server_port {
          max-width: 212px
        }
        input {
          width: 100%;
          border: none;
          outline: none;
          padding: 0;
          height: 33px;
          font-size: 14px;
          font-weight: 400;
          background: none;
          border-radius: 0;
          color: #66615b!important;
          transition: all .4s ease;
          border-bottom: 1px solid #515459;
          background-color: transparent!important;
          font-family: Roboto,sans-serif;
          caret-color: #c3c7ca;
        }
      }
    }
    &--line {
      border-bottom: 1px solid #cecfd1;
      margin: 5px 0;
    }
  }

  &__buttons {
    border-top: 1px solid #cecfd1;
    padding: 24px;
    display: flex;
    justify-content: space-between;
  }

  &__containerSettings {
    color: white;
    background: white;
    border-radius: 2px;
    max-width: 380px;
    width: 100%;
    margin-right: 24px;
    margin-bottom: 10px;
  }
}

.vue-select {
  .vs__dropdown-toggle {
    border: none !important;
    border-bottom: 1px solid #515459 !important;
    color: #c3c7ca;
    background: none;
  }
  input {
    color: #c3c7ca;
    padding: 0;
  }
}

.additionally {
  background: white;
  //padding: 10px 0;
  padding: 0 10px;
  border: 1px solid #3a3c40;
  border-radius: 4px;
}

.vs__selected {
  padding: 2px 12px;
  border-radius: 15px;
  background-color: #006937;
}

@media (max-width: 600px) {
  .edit-wan-modal {
    &__container {
      max-height: 400px;
      &--row {
        .row__input {
          max-width: 150px;
          &--3blocks {
            max-width: 100px !important;
          }
          &.server_port {
            max-width: 115px !important;
          }
        }
      }
    }
  }
}

.hide_text{
  width: 300px;
  position: absolute;
  bottom: -43px;
  left: 85px;
  white-space: normal;
  background: #f9f9f9;
  padding: 10px;
  border-radius: 5px;
  transition: 0.2s;
  box-shadow: 1px 1px 5px #202020;
  opacity: 0;
  z-index: -1;
  &.name {
    bottom: -76px;
    left: 9px;
    //transform: translateX(200px);
  }
  &.mode {
    bottom: -75px;
    left: -289px;
    //transform: translateX(-200px);
  }
  &.default_route {
    bottom: -69px;
    left: 10px;
    color: #c3c7ca;
    font-size: 13px;
    font-weight: bold;
    //transform: translateX(-200px);
  }
  &.method_ipv4 {
    bottom: 22px;
    left: 14px;
    color: #c3c7ca;
    font-size: 13px;
    font-weight: bold;
    position: absolute;
    //transform: translateX(-200px);
  }
  &.server{
    bottom: 20px;
    left: 13px;
    position: absolute;
  }
  &.port{
    bottom: 21px;
    left: -293px;
    position: absolute;
  }
  &.ip_address {
    bottom: 22px;
    left: 10px;
  }
  &.mask {
    bottom: 22px;
    left: 10px;
  }
  &.gateway {
    bottom: 22px;
    left: -293px;
  }
  &.interfaces {
    bottom: 22px;
    left: 10px;
  }
  &.usage_policy {
    bottom: 22px;
    left: 10px;
    color: #c3c7ca;
    font-size: 13px;
    font-weight: bold;
  }
  &.mtu {
    bottom: 22px;
    left: 10px;
  }
  &.password {
    bottom: 22px;
    left: 10px;
  }
  &.active{
    opacity: 1;
    z-index: 1;
    transform: translate(0,0);
  }
}
</style>
